// extracted by mini-css-extract-plugin
export default {"container":"style_container__EJT42","content":"style_content__BZmqM","errorText":"style_errorText__BpgP+","recapture":"style_recapture__MfAt+"};